<script setup lang="ts">
  import { Dialog } from "@/base-components/Headless";
  import Button from "@/base-components/Button";
  import Lucide from "@/base-components/Lucide";
  import { ref } from "vue";

  const { isOpen, pass } = defineProps({
    isOpen: { type: Boolean, required: true },
    pass: { type: String, required: true },
  });
  const emits = defineEmits(["close", "accept"]);

  const isLoading = ref(true);
  const pricingList = ref<{ key: string; price: string }[]>([]);
  const selectedPrice = ref<{ key: string; price: string }>();
</script>

<template>
  <Dialog size="xl" :open="isOpen" @close="emits('close')">
    <Dialog.Panel class="rounded-md">
      <Dialog.Title class="bg-primary rounded-t-md text-white">
        <div class="relative w-full h-5">
          <strong class="text-base">
            {{ $t("title.showPassword") }}
          </strong>
        </div>
        <div
          @click="emits('close')"
          class="absolute top-3 end-3 mt-0 me-1 cursor-pointer w-5 h-5 bg-secondary rounded-full"
        >
          <Lucide icon="X" class="w-5 h-5 font-bold text-black" />
        </div>
      </Dialog.Title>
      <div class="flex justify-center mt-6">
        <strong class="ml-2">پسورد:</strong>
        <span class="">{{ pass }}</span>
      </div>
      <Dialog.Footer>
        <div class="flex col-md-12 items-end justify-end gap-2">
          <Button
            variant="outline-secondary"
            @click="emits('close')"
            size="sm"
            class="shadow-md justify-end items-end"
          >
            {{ $t("button.cancel") }}
          </Button>
        </div>
      </Dialog.Footer>
    </Dialog.Panel>
  </Dialog>
</template>

<style scoped></style>
